import { DrawingTool, DrawingToolType, ShapeConfig } from './drawing-tool';

export class ArrowDrawingTool extends DrawingTool {

    protected readonly TOOL_TYPE: DrawingToolType = DrawingToolType.ARROW;

    private pointerWidth: number = 20;
    private pointerLength: number = 20;

    public constructor(strokeWidth, strokeColor, pointerWidth, pointerLength) {
        super(strokeWidth, strokeColor)
        this.pointerWidth = pointerWidth
        this.pointerLength = pointerLength
    }

    public addNewShape(shapeX, shapeY, shapeId, color?: string, parameters?: any) {
        const newShape =
            {
                id: this.generateShapeId(shapeId),
                type: this.TOOL_TYPE,

                fill: color || this.strokeColor,
                opacity: this.DEFAULT_OPACITY,
                stroke: color || this.strokeColor,
                strokeWidth: this.strokeWidth,

                x: shapeX,
                y: shapeY,

                pointerLength: this.pointerLength,
                pointerWidth: this.pointerWidth,
                points: [0, 0, 0, 0],
                refresh: '', // used to trigger Vue.js watch as pushing in array doesn't do it
            } as ShapeConfig
        return newShape;
    }

    public onTouchMove(currentShape, currentX, currentY, startX, startY) {

        currentShape.points[2] = currentX - startX
        currentShape.points[3] = currentY - startY

        currentShape.refresh = currentX
    }

    public onTouchEnd(currentShape, endX, endY, startX, startY) {
        this.onTouchMove(currentShape, endX, endY, startX, startY)
    }

    public resetTool() {
        // this method remains empty for this implementation
    }

}